<template>
    <div class="store-cover-image"></div>
</template>

<script>
export default {
    name: 'StoreCoverImage',
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
</script>

<style lang="less" scoped>
[service='moonlight blade'],
[service='Moonlight Blade'] {
    .store-cover-image {
        background-image: url('../../../public/static/images/products/moonlight-blade/moonlight-blade_cover.png');
    }
}
.store-cover-image {
    background-position: center;
    background-repeat: no-repeat;
    height: 335px;
}
@media (max-width: 1440px) {
    [service='moonlight blade'],
    [service='Moonlight Blade'] {
        .store-cover-image {
            background-image: url('../../../public/static/images/products/moonlight-blade/moonlight-blade_cover_1440.png');
        }
    }
}
@media (max-width: 768px) {
    .store-cover-image {
        height: 250px;
    }
    [service='moonlight blade'],
    [service='Moonlight Blade'] {
        .store-cover-image {
            background-image: url('../../../public/static/images/products/moonlight-blade/moonlight-blade_cover_768.png');
        }
    }
}
</style>
